import {AppSettings} from '../constants';
import Loadable from 'react-loadable';
import Loading from 'components/Loading';

const ManageSetting = Loadable({
  loader: () => import('./Containers/manage-setting'),
  loading: Loading
});

export default [
  {
    path: '/setting',
    component: ManageSetting,
    private: true,
    menu: {
      name: 'Settings',
      group: 'Admin',
      order: 10,
      subGroup: 'General',
      icons: 'icon-setting-ic',
      condition: () => {
        return AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI;
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/Setting/routes.js